import { render, staticRenderFns } from "./DefaultCharges.vue?vue&type=template&id=56f69c86&scoped=true&"
import script from "./DefaultCharges.vue?vue&type=script&lang=js&"
export * from "./DefaultCharges.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCharges.vue?vue&type=style&index=0&id=56f69c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f69c86",
  null
  
)

export default component.exports